/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Number_SignInputs */

const en_ccsl_export_header_number_sign = /** @type {(inputs: Ccsl_Export_Header_Number_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const fr_ccsl_export_header_number_sign = /** @type {(inputs: Ccsl_Export_Header_Number_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const de_ccsl_export_header_number_sign = /** @type {(inputs: Ccsl_Export_Header_Number_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const it_ccsl_export_header_number_sign = /** @type {(inputs: Ccsl_Export_Header_Number_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const ru_ccsl_export_header_number_sign = /** @type {(inputs: Ccsl_Export_Header_Number_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const es_ccsl_export_header_number_sign = /** @type {(inputs: Ccsl_Export_Header_Number_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const zh_cn2_ccsl_export_header_number_sign = /** @type {(inputs: Ccsl_Export_Header_Number_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const ja_ccsl_export_header_number_sign = /** @type {(inputs: Ccsl_Export_Header_Number_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const hi_ccsl_export_header_number_sign = /** @type {(inputs: Ccsl_Export_Header_Number_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

const pt_pt2_ccsl_export_header_number_sign = /** @type {(inputs: Ccsl_Export_Header_Number_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#`)
};

/**
* | output |
* | --- |
* | "#" |
*
* @param {Ccsl_Export_Header_Number_SignInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_number_sign = /** @type {((inputs?: Ccsl_Export_Header_Number_SignInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Number_SignInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_number_sign(inputs)
	if (locale === "de") return de_ccsl_export_header_number_sign(inputs)
	if (locale === "it") return it_ccsl_export_header_number_sign(inputs)
	if (locale === "ru") return ru_ccsl_export_header_number_sign(inputs)
	if (locale === "es") return es_ccsl_export_header_number_sign(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_number_sign(inputs)
	if (locale === "ja") return ja_ccsl_export_header_number_sign(inputs)
	if (locale === "hi") return hi_ccsl_export_header_number_sign(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_number_sign(inputs)
	return en_ccsl_export_header_number_sign(inputs)
});